import React from 'react';
import { Button, Tooltip } from 'antd';
import { ExpandOutlined } from '@ant-design/icons';
import { useTranslation } from '@hooks/index';
import styles from './MinimizedPanel.module.css';

type Props = {
  /**
   * Panel title to display
   */
  title: string;
  /**
   * Callback when expand button is clicked
   */
  onExpand: () => void;
  /**
   * Unique identifier for this panel
   */
  panelId: string;
}

/**
 * Renders a minimized panel as a compact bar with title and expand button
 */
const MinimizedPanel = (props: Props) => {
  const { title, onExpand, panelId } = props;
  const t = useTranslation('CommonWords');

  return (
    <div className={styles.MinimizedPanel} data-panel-id={panelId}>
      <span className={styles.Title}>{title}</span>
      <Tooltip title={t('Expand', 'Expand')} placement="top">
        <Button
          type="text"
          icon={<ExpandOutlined />}
          onClick={onExpand}
          className={styles.ExpandButton}
          size="small"
        />
      </Tooltip>
    </div>
  );
};

export default MinimizedPanel;

